import { Icon, IconProps } from '../Icon.component';

type AISearchIconProps = IconProps & {
  showGradient?: boolean;
  fillColor?: string;
};

export const AISearchIcon: React.FC<React.PropsWithChildren<AISearchIconProps>> = ({
  showGradient = true,
  fillColor,
  ...props
}) => (
  <Icon size={14} {...props} viewBox='0 0 14 14'>
    <path
      d='M4.75098 0.106929C5.29546 0.0118734 5.74707 0.469205 5.74707 1.02197C5.74694 1.57466 5.29104 2.00928 4.75781 2.15478C3.16841 2.5884 2.00004 4.04111 2 5.76806C2.00018 7.83735 3.67776 9.51505 5.74707 9.51513C7.33241 9.51502 8.68737 8.53023 9.23438 7.13916C9.42195 6.66217 9.84102 6.27508 10.3535 6.2749C10.9544 6.2749 11.4341 6.79455 11.2666 7.37158C11.0889 7.98306 10.8119 8.55289 10.4551 9.06201L13.0225 11.6284C13.4128 12.0189 13.4127 12.652 13.0225 13.0425C12.632 13.433 11.9989 13.4328 11.6084 13.0425L9.04102 10.4761C8.10811 11.1299 6.97273 11.5151 5.74707 11.5151L5.45117 11.5073C2.51273 11.3582 0.155979 9.00238 0.00683594 6.06396L0 5.76806C4.14312e-05 2.93387 2.05183 0.578782 4.75098 0.106929ZM5.07324 4.09326C5.17942 3.82129 5.56374 3.82129 5.66992 4.09326C5.93055 4.7606 6.45862 5.28871 7.12598 5.54931C7.39794 5.65549 7.39794 6.03981 7.12598 6.14599C6.45862 6.40659 5.93056 6.93471 5.66992 7.60205C5.56374 7.87401 5.17942 7.87401 5.07324 7.60205C4.81259 6.93462 4.28367 6.40657 3.61621 6.14599C3.3449 6.0396 3.34489 5.65569 3.61621 5.54931C4.28369 5.28872 4.8126 4.7607 5.07324 4.09326ZM8.69141 0.294429C8.84497 -0.098115 9.40118 -0.0981715 9.55469 0.294429C9.93122 1.2589 10.6938 2.02235 11.6582 2.39892C12.0512 2.55233 12.0512 3.10879 11.6582 3.2622C10.6939 3.63878 9.93122 4.40138 9.55469 5.36572C9.40127 5.75867 8.84482 5.75867 8.69141 5.36572C8.31491 4.40141 7.55213 3.63882 6.58789 3.2622C6.19493 3.10879 6.19493 2.55233 6.58789 2.39892C7.55224 2.02232 8.3149 1.25883 8.69141 0.294429Z'
      fill={showGradient ? 'url(#aiSearchGradient)' : fillColor ?? 'currentColor'}
    />
    {showGradient && (
      <defs>
        <linearGradient id='aiSearchGradient' x1='0' y1='0' x2='13.9625' y2='0.716282' gradientUnits='userSpaceOnUse'>
          <stop offset='0.485' stopColor='#146EF5' />
          <stop offset='1' stopColor='#C467DE' />
        </linearGradient>
      </defs>
    )}
  </Icon>
);
